import { render, staticRenderFns } from "./StudentLightCourseLessons.vue?vue&type=template&id=b59e4ed6&scoped=true&"
import script from "./StudentLightCourseLessons.vue?vue&type=script&lang=js&"
export * from "./StudentLightCourseLessons.vue?vue&type=script&lang=js&"
import style0 from "./StudentLightCourseLessons.vue?vue&type=style&index=0&id=b59e4ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59e4ed6",
  null
  
)

export default component.exports